import { applyMiddleware, createStore, Middleware, Store } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { rootSaga } from '../sagas'
import {
  loadConfigState,
  loadEventsState,
  saveConfigState,
  saveEventsState,
} from '../services/localStorage'
import createRootReducer from './index'

const sagaMiddleware = createSagaMiddleware()

const bindMiddleware = (middleware: Middleware[]) => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('redux-devtools-extension')
    return composeWithDevTools(applyMiddleware(...middleware))
  }
  return applyMiddleware(...middleware)
}

const configStore = (): Store => {
  const store = createStore(
    createRootReducer,
    {
      config: loadConfigState(),
      events: loadEventsState(),
    },
    bindMiddleware([sagaMiddleware]),
  )

  store.subscribe(() => {
    saveConfigState(store.getState().config)
    saveEventsState(store.getState().events)
  })

  sagaMiddleware.run(rootSaga)

  return store
}

export default configStore
